import { useEffect } from "react";
import { useHistory } from "react-router-dom";

const AccountContainer = () => {
  const history = useHistory();

  useEffect(() => {
    history.push("/account/profile");
  }, []);

  return null;
};

export default AccountContainer;
